import { useEffect } from "react";
import Nav from "@/components/site/Nav";
import FlagStripe from "@/components/site/FlagStripe";
import EventCard from "@/components/site/EventCard";
import { UPCOMING_EVENTS } from "@/data/events";

/**
 * Public /events page. Reuses the SAME event data + EventCard component that
 * /legacy consumes — never rewrite event information here.
 */
export default function Events() {
  useEffect(() => {
    // Preserve the standard SWS meta pattern used across public pages.
    document.title = "Upcoming Events · Sweat With Slay";
  }, []);

  return (
    <main data-testid="events-page" className="bg-[#0A0A0A] text-white font-body min-h-screen pt-20">
      <Nav />
      <FlagStripe position="top" data-testid="events-flag-stripe-top" />

      <section className="px-4 md:px-8 py-20 md:py-28 max-w-5xl mx-auto">
        <p className="text-[#B32027] uppercase tracking-[0.4em] text-xs font-bold mb-4">/ Move with us</p>
        <h1 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl mb-8">
          Upcoming <span className="text-[#B32027]">Events.</span>
        </h1>
        <p className="text-white/85 text-lg md:text-xl leading-relaxed max-w-3xl mb-14">
          Sweat With Slay is more than a workout plan. Join us for local challenges, charity events, races, climbs, community workouts, and other opportunities to move for something bigger.
        </p>

        {UPCOMING_EVENTS.length > 0 ? (
          <div className="space-y-6" data-testid="events-list">
            {UPCOMING_EVENTS.map((ev) => (
              <EventCard key={ev.id} event={ev} />
            ))}
          </div>
        ) : (
          <div
            data-testid="events-empty-state"
            className="border-2 border-white/15 bg-[#0F0F0F] p-10 md:p-14 text-center"
          >
            <p className="text-[#B32027] uppercase tracking-[0.4em] text-[10px] font-bold mb-3">/ Stay tuned</p>
            <p className="font-display font-black uppercase tracking-tighter leading-[0.95] text-3xl md:text-5xl text-white">
              More events are coming. <span className="text-[#B32027]">Check back soon.</span>
            </p>
          </div>
        )}
      </section>

      <FlagStripe position="bottom" data-testid="events-flag-stripe-bottom" />
    </main>
  );
}
